import oa_request from '../utils/oa-request'
import request from '../utils/request'
import Vue from 'vue';

//获取用户列表
export function customlist(data) {
    return oa_request({
        url: '/client/table',
        method: 'get',
        params: data
    })
}

//获取头部列表
export function headlist(data) {
    return oa_request({
        url: '/common/field',
        method: 'get',
        params: data
    })
}

//获取头部列表
export function saerchlist(data) {
    return oa_request({
        url: '/client/search',
        method: 'get',
        params: data
    })
}

//获取标单选择列表
export function selectlist(data) {
    return oa_request({
        url: '/client/save',
        method: 'get',
        params: data
    })
}

//添加客户
export function addcustom(data) {
    return oa_request({
        url: '/client/save',
        method: 'post',
        data
    })
}

//修改客户信息
export function editcustom(data) {
    return oa_request({
        url: '/client/edit',
        method: 'post',
        data
    })
}

// //获取客户详情
// export function customdetail(data){
//     return oa_request({
//         url:'/client/detail',
//         method:'get',
//         params:data
//     })
// }

//获取客户详情
export function customdetail(data) {
    return oa_request({
        url: '/v1/client/clientDetail',
        method: 'get',
        params: data
    })
}

//导出文件
export function exportfile(data) {
    return oa_request({
        url: '/client/export',
        method: 'post',
        data
    })
}

//单个删除客户
export function deluser(data) {
    return oa_request({
        url: '/client/delete',
        method: 'delete',
        params: data
    })
}

// 批量删除客户
export function delmoreuser(data) {
    return oa_request({
        url: '/client/del',
        method: 'delete',
        data
    })
}

//获取企业信息
export function com_customlist(data) {
    return oa_request({
        url: '/v1/client/addTypeClient',
        method: 'get',
        params: data
    })
}

//添加线索客户
export function com_addcustom(data) {
    return oa_request({
        url: '/v1/client/addTypeClient',
        method: 'post',
        data
    })
}

//编辑联系人
export function com_editcustom(data) {
    return oa_request({
        url: '/v1/client/addTypeClient',
        method: 'post',
        data
    })
}

//删除联系人
export function com_delcustom(data) {
    return oa_request({
        url: '/v1/client/delLinkMan',
        method: 'delete',
        data
    })
}

//添加跟进记录
export function addfollow(data) {
    return oa_request({
        url: '/v1/client/addFollowRecord',
        method: 'post',
        data
    })
}

//获取跟进记录
export function followlist(data) {
    return oa_request({
        url: '/v1/client/followRecordList',
        method: 'get',
        params: data
    })
}

//获取企业详情
export function com_customdetail(data) {
    return oa_request({
        url: '/v1/client/clientDetail',
        method: 'get',
        params: data
    })
}

//修改客户名称
export function customedit(data) {
    return oa_request({
        url: '/v1/client/alterClientType',
        method: 'post',
        data
    })
}

//新建个人客户
export function custom_add_personal(data) {
    return oa_request({
        url: '/v2/client/addPersonClient',
        method: 'post',
        data
    })
}

//新建个人客户
export function custom_add_company(data) {
    return oa_request({
        url: '/v2/client/addCompanyClient',
        method: 'post',
        data
    })
}

//客户管理下拉
export function custom_select(data) {
    return oa_request({
        url: '/v2/client/allClient',
        method: 'get',
        params: data
    })
}

//客户列表
export function custom_new_list(data, signal) {
    return oa_request({
        url: '/v2/client/normalList',
        method: 'get',
        params: data,
        signal: signal
    })
}
//客户下拉房号管理单独使用
export function searchClients(data) {
    return oa_request({
        url: '/v2/client/searchClients',
        method: 'get',
        params: data
    })
}

//客户管理（新版权限）
// export function custom_new_list(data){
//     return oa_request({
//         url:'/v3/client/authClientList',
//         method:'get',
//         params:data
//     })
// }

//客户列表
export function custom_add_helper(data) {
    return oa_request({
        url: '/v2/client/addTeamAdmin',
        method: 'post',
        data
    })
}

//客户详情
export function custom_new_detail(data) {
    return oa_request({
        url: '/v2/client/detail',
        method: 'get',
        params: data
    })
}

//编辑个人客户
export function custom_edit_personal(data) {
    return oa_request({
        url: '/v2/client/editPersonClient',
        method: 'post',
        data
    })
}

//编辑企业客户
export function custom_edit_company(data) {
    return oa_request({
        url: '/v2/client/editCompanyClient',
        method: 'post',
        data
    })
}

//获取跟进记录下拉
export function follow_select(data) {
    return oa_request({
        url: '/v2/client/recordOptions',
        method: 'get',
        params: data
    })
}

//添加跟进记录
export function add_follow(data) {
    return oa_request({
        url: '/v2/client/addRecord',
        method: 'post',
        data
    })
}

//编辑跟进记录
export function edit_follow(data) {
    return oa_request({
        url: '/v2/client/editRecord',
        method: 'post',
        data
    })
}

//跟进记录列表
export function follow_list(data) {
    return oa_request({
        url: '/v2/client/recordList',
        method: 'get',
        params: data
    })
}

//删除跟进记录
export function del_follow(data) {
    return oa_request({
        url: '/v2/client/delRecord',
        method: 'post',
        data
    })
}

//获取跟进记录历史数据
export function custom_old_detail(data) {
    return oa_request({
        url: '/v2/client/clientOldData',
        method: 'get',
        params: data
    })
}

//检查客户是否在系统中
export function customcheck(data) {
    return oa_request({
        url: '/v2/client/clientIsExist',
        method: 'post',
        data
    })
}

//处理代办
export function dealremind(data) {
    return request({
        url: '/v2/msg/remind/dealRemind',
        method: 'post',
        data
    })
}

//添加联系人
export function addlinkman(data) {
    return oa_request({
        url: '/v2/client/addLinkman',
        method: 'post',
        data
    })
}

//编辑联系人
export function editlinkman(data) {
    return oa_request({
        url: '/v2/client/editLinkman',
        method: 'post',
        data
    })
}

//删除联系人
export function dellinkman(data) {
    return oa_request({
        url: '/v2/client/delLinkman',
        method: 'post',
        data
    })
}

//绑定客户企业
export function base_edit(data) {
    return request({
        url: '/v2/wx/WxCustomer/base_edit',
        method: 'post',
        data
    })
}

//放弃线索客户
export function giveupcustom(data) {
    return oa_request({
        url: '/v2/client/giveUpCompany',
        method: 'post',
        data
    })
}

//导入企业
export function updatecompany(data) {
    return oa_request({
        url: '/v2/client/importUpdateClient',
        method: 'get',
        params: data
    })
}


//导出企业
export function exportcompany(data) {
    return oa_request({
        url: '/v2/client/exportAllClientName',
        method: 'get',
        params: data
    })
}


//新版导出
export function exportcustom(data) {
    return oa_request({
        // url:'/v3/Client/exportDataQueue',
        url: `${Vue.prototype.$BASE_EXPORT_URL}/v1/export/exportClient`,
        method: 'get',
        params: data
    })
}
//新版导出-进度
export function exportcustomprocess(data) {
    return oa_request({
        url: '/v3/Client/exportProgress',
        method: 'get',
        params: data
    })
}


//更新客户清楚代办
export function clearpersonal(data) {
    return oa_request({
        url: '/v2/client/delClientTuenRemind',
        method: 'get',
        params: data
    })
}



//客户联系人列表
export function clientLinkManList(data) {
    return oa_request({
        url: '/v3/Client/clientLinkManList',
        method: 'get',
        params: data
    })
}

//客户联系人列表
export function editClientLinkManList(data) {
    return oa_request({
        url: '/v3/Client/editClientLinkManList',
        method: 'post',
        data
    })
}




//新版 线索信息 - 列表
export function clueInfoList(data) {
    return oa_request({
        url: '/v5/clue/list',
        method: 'get',
        params: data
    })
}

//新版 线索信息 - 新建
export function clueInfoAdd(data) {
    return oa_request({
        url: '/v5/clue/add',
        method: 'post',
        data
    })
}

//新版 线索信息 - 编辑
export function clueInfoEdit(data) {
    return oa_request({
        url: '/v5/clue/edit',
        method: 'post',
        data
    })
}

//新版 线索信息 - 详情
export function clueInfoDetail(data) {
    return oa_request({
        url: '/v5/clue/detail',
        method: 'get',
        params: data
    })
}

//新版 线索信息 - 修改状态
export function editFollowStatus(data) {
    return oa_request({
        url: '/v5/clue/editFollowStatus',
        method: 'post',
        data
    })
}

//新版 线索信息 - 删除
export function delCLue(data) {
    return oa_request({
        url: '/v5/clue/delCLue',
        method: 'post',
        data
    })
}

//新版 线索信息 - 更改星级
export function editStar(data) {
    return oa_request({
        url: '/v5/clue/editStar',
        method: 'post',
        data
    })
}

//新版 跟进记录 - 添加
export function addFollowRecord(data) {
    return oa_request({
        url: '/v5/clue/addFollowRecord',
        method: 'post',
        data
    })
}

//新版 跟进记录 - 编辑
export function editFollowRecord(data) {
    return oa_request({
        url: '/v5/clue/editFollowRecord',
        method: 'post',
        data
    })
}

//新版 跟进记录 - 删除
export function delFollowRecord(data) {
    return oa_request({
        url: '/v5/clue/delFollowRecord',
        method: 'post',
        data
    })
}

//新版 跟进记录 - 列表
export function followRecordList(data) {
    return oa_request({
        url: '/v5/clue/followRecordList',
        method: 'get',
        params: data
    })
}


//查询为负责人的客户
export function principalClient(data, signal) {
    return oa_request({
        url: '/v5/client/principalClient',
        method: 'get',
        params: data,
        signal: signal
    })
}

//关联客户
export function associateClient(data) {
    return oa_request({
        url: '/v5/clue/associateClient',
        method: 'post',
        data,
    })
}

//查询客户绑定的销售机会，排除掉已经选择的
export function clientBindSell(data) {
    return oa_request({
        url: '/v5/clue/clientBindSell',
        method: 'get',
        params: data,
    })
}

//重点跟进
export function importantFollow(data) {
    return oa_request({
        url: '/v5/clue/importantFollow',
        method: 'post',
        data,
    })
}


//查询销售机会绑定的合同，排除掉已经选择的
export function sellBindContract(data) {
    return oa_request({
        url: '/v5/clue/sellBindContract',
        method: 'get',
        params: data,
    })
}


//已成交
export function dealMade(data) {
    return oa_request({
        url: '/v5/clue/dealMade',
        method: 'post',
        data,
    })
}

//查询合同绑定的回款，排除掉已经选择的
export function contractBindPayBack(data) {
    return oa_request({
        url: '/v5/clue/contractBindPayBack',
        method: 'get',
        params: data,
    })
}


